import React, { useEffect, useState, useContext, useRef, useCallback, useReducer } from "react";
import Footer from "../layouts/Footer";
import HeaderUploadStatus from "../components/HeaderUploadStatus";
import "./Upload.css";
import { Col, Row, Table, Container, Card, InputGroup, FormControl, Modal, Button, Dropdown } from "react-bootstrap";
import { GrNext, GrPrevious } from "react-icons/gr";

import "./Upload.css";
import prettyBytes from "pretty-bytes";
import prettyMs from "pretty-ms";
import useFetchData from "../components/useFetchData";
import usePutData from "../components/useFetchPut";
import { useNavigate, useLocation } from "react-router-dom";

// import { ReactComponent as SuccessUpload } from "bootstrap-icons/icons/check-circle.svg";
// import { ReactComponent as CancelUpload } from "bootstrap-icons/icons/dash-circle.svg";
// import { ReactComponent as PendingUpload } from "bootstrap-icons/icons/clock.svg";
// import { ReactComponent as ErrorUpload } from "bootstrap-icons/icons/x-circle.svg";

import SuccessUpload from "bootstrap-icons/icons/check-circle.svg?react";
import CancelUpload from "bootstrap-icons/icons/dash-circle.svg?react";
import PendingUpload from "bootstrap-icons/icons/clock.svg?react";
import ErrorUpload from "bootstrap-icons/icons/x-circle.svg?react";


import { AuthContext } from "../Context/AuthContext";
import ModalDialogue from "../components/ModalDialogue";
import { uploadFileEmitter } from "../components/UploadFileEmitter";
import { uploadDiag, uploadDiagDump, describeSignedUrl } from "../utils/uploadDiag";

function IconSearch(props) {
   return (
      <svg viewBox="0 0 1024 1024" fill="currentColor" height="1em" width="1em" {...props}>
         <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" />
      </svg>
   );
}

//use this for the modal dialgue its an object
const initialModalDialgueState = {
   isOpen: false,
   question: "",
};

const reducer = (state, action) => {
   //switch is another way to perform if else if nothing matches it goes to default
   switch (action.type) {
      case "OPEN_MODAL":
         return { ...state, isOpen: true, question: action.payload.question };
      case "CLOSE_MODAL":
         return { ...state, isOpen: false };
      default:
         return state;
   }
};

export default function Uploadupdate({ onSkin }) {
   const navigate = useNavigate();
   const location = useLocation();
   //const context = useContext(AccountContext);
   //const { getSession } = context;

   const { userClaims, orgInfo } = useContext(AuthContext);
   const fullName = [userClaims?.fn, userClaims?.ln].filter(Boolean).join(" ");
   const sessionData = {
         userId: userClaims?.userId,
         iconId: orgInfo?.iconId,
    };
   const [error, setError] = useState(null);
   const [nextPage, setNextPage] = useState("");

   const [modalDialgueState, dispatchModal] = useReducer(reducer, initialModalDialgueState); // Start of Modal Dialogue state
   const { isOpen, question } = modalDialgueState; // Destructure modal state

   // controlls header background
   const [uploadStatus, setUploadstatus] = useState("status-uploading");

   // variables to upload updates
   const [progress, setProgress] = useState(0);
   const [remainingFiles, setRemainingFiles] = useState(0);
   const [remainingSize, setRemainingSize] = useState(0);
   const [remainingTime, setRemainingTime] = useState("");
   const [uploadSpeed, setUploadSpeed] = useState(0);
   const [totalUploaded, setTotalUploaded] = useState(0);
   const [totalElapsedTime, setTotalElapsedTime] = useState("");
   const isUserInitiatedAbort = useRef(false);

   // Define the AbortController here
   const abortController = useRef(new AbortController());

   const isNavigating = useRef(false);

   // Navigate away if there's no file array or file array is empty
   useEffect(() => {
      if (!location.state || location.state.length === 0) {
         navigate("/apps/upload");
      }
   }, [location.state, navigate]);

   const [files, setFiles] = useState(location.state?.files || []);

   const { fetchData } = useFetchData();
   const { putData } = usePutData();
   const [fileCount, setFileCount] = useState(0);
   const [totalBytes, setTotalBytes] = useState(0);
   const [currentPage, setCurrentPage] = useState(1);
   const [totalPages, setTotalPages] = useState(1);
   const [searchTerm, setSearchTerm] = useState("");
   const [uploading, setUploading] = useState(false);
   const [uploadError, setUploadError] = useState(false);
   const [errorUploading, setErrorUploading] = useState(null);
   const filesRef = useRef(files);
   const [startTime, setStartTime] = useState(Date.now());

   const itemsPerPage = 10;

   const filteredFiles = files.filter((file) => file.name.toLowerCase().includes(searchTerm.toLowerCase()));
   const currentFiles = filteredFiles.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

   useEffect(() => {
      document.body.classList.add("app-task");
      return () => {
         document.body.classList.remove("app-task");
      };
   }, []);
   useEffect(() => {
      setFileCount(files.length); // Update file count whenever files state changes
      setTotalBytes(files.reduce((sum, file) => sum + file.size, 0)); // Update total bytes whenever files state changes

      const calculatedTotalPages = Math.ceil(filteredFiles.length / itemsPerPage);
      setTotalPages(calculatedTotalPages > 0 ? calculatedTotalPages : 1);
   }, [files]);
   useEffect(() => {
      const checkedFilesOnPage = filteredFiles.filter((file) => file.isChecked && file.index >= (currentPage - 1) * itemsPerPage && file.index < currentPage * itemsPerPage);
   }, [filteredFiles, currentPage]);

   const handlePageChange = (pageNumber) => {
      // Uncheck files on the current page before proceeding
      setFiles((prevFiles) => prevFiles.map((file) => (file.index >= (currentPage - 1) * itemsPerPage && file.index < currentPage * itemsPerPage ? { ...file, isChecked: false } : file)));
      //console.log("HANDLEPAGECHANGE", pageNumber);
      setCurrentPage(pageNumber);
   };

   const Pagination = ({ totalPages, currentPage, onPageChange }) => {
      //console.log("CURRENTPAGE:", currentPage);
      const pageNumbers = [];
      const maxPagesToShow = 7;

      for (let i = 1; i <= totalPages; i++) {
         pageNumbers.push(i);
      }

      const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
      const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

      const renderPageNumbers = () => {
         const pages = [];

         pages.push(
            <li key="prev" className="pagination-item">
               <button onClick={() => onPageChange(currentPage - 1)} className="page-link">
                  <GrPrevious size={20} />
               </button>
            </li>
         );

         if (startPage > 2) {
            pages.push(
               <li key="ellipsis1" className="pagination-item disabled">
                  <span className="page-link">...</span>
               </li>
            );
         }
         for (let i = startPage; i <= endPage; i++) {
            pages.push(
               <li key={i} className={`pagination-item ${i === currentPage ? "active" : ""}`}>
                  <button onClick={() => onPageChange(i)} className="page-link">
                     {i}
                  </button>
               </li>
            );
         }
         if (endPage < totalPages - 1) {
            pages.push(
               <li key="ellipsis2" className="pagination-item disabled">
                  <span className="page-link">...</span>
               </li>
            );
         }

         pages.push(
            <li key="next" className="pagination-item">
               <button onClick={() => onPageChange(currentPage + 1)} className="page-link">
                  <GrNext size={20} />
               </button>
            </li>
         );

         return pages;
      };

      return <ul className="pagination">{renderPageNumbers()}</ul>;
   };

   const uploadFileToS3 = async (signedUrl, file, uid) => {
      try {
         const result = await putData(signedUrl, "PUT", file.fileObject, file.type, file.name, file.size, file.docType, uid, fullName, sessionData.iconId);
         console.log("S3-RESPONSE:", result.st, result.message);
         if (result.st !== 1) {
            console.error(`Upload failed for "${file.name}":`, result.message);
         }
         return { st: result.st, ms: result.message };
      } catch (error) {
         console.error(`Upload exception for "${file.name}":`, error);
         return { st: -2, ms: error?.message || "Unexpected upload error" };
      }
   };

   function normalizeFileName(name) {
      return name.normalize("NFKD").replace(/[^\x00-\x7F]/g, "");
   }

   const uploadFiles = async () => {
      setUploading(true);
      setErrorUploading(null);
      uploadFileEmitter.emit("uploadStart"); // Notify that upload has started

      if (!navigator.onLine) {
         setError("Network connection is lost");
         setUploadstatus("status-error");
         uploadFileEmitter.emit("uploadError"); // Notify error
         abortController.current.abort();
         return;
      }

      let presignedCount = 0;
      let url = "/geturl.sz";
      let method = "POST";
      let contentType = "application/x-www-form-urlencoded";
      let signurl = "";

      const totalFileSize = files.reduce((total, file) => total + file.size, 0);
      let uploadedSize = 0;

      uploadDiag("batch_start", {
         fileCount: files.length,
         fileNames: files.map((f) => f.name),
         totalFileSize,
         origin: typeof window !== "undefined" ? window.location.origin : null,
      });

      for (let i = 0; i < files.length; i++) {
         if (abortController.current.signal.aborted) {
            console.log("Upload cancelled");
            // Check if the abort was user-initiated
            if (isUserInitiatedAbort.current) {
               setUploadstatus("status-cancel");
               uploadFileEmitter.emit("uploadEnd"); // Notify upload ended (cancelled)
            } else {
               setUploadError("Upload cancelled due to network issues.");
               setUploadstatus("status-error");
               uploadFileEmitter.emit("uploadError"); // Notify error
            }
            return;
         }

         const file = files[i];

         const meta = { doc_orig_name: normalizeFileName(file.name), doc_type: file.type, doc_size: file.size.toString(), ocr_type: file.docType, icon_src: sessionData.iconId };
         const body = { meta: JSON.stringify(meta) };

         uploadDiag("presign_request", { index: i, total: files.length, file: file.name, size: file.size, docType: file.docType, meta });

         try {
            const { responseData, fetchLoading, fetchError } = await fetchData(url, method, body, contentType, { signal: abortController.current.signal });

            uploadDiag("presign_response", {
               index: i,
               file: file.name,
               st: responseData?.st,
               uid: responseData?.payload?.[0]?.uid,
               signedUrl: responseData?.payload?.[0]?.signurl ? describeSignedUrl(responseData.payload[0].signurl) : null,
               fetchError: fetchError || null,
               hasResponse: !!responseData,
            });
            if (!responseData) {
               setFiles((prevFiles) => {
                  const updatedFiles = [...prevFiles];
                  updatedFiles[i] = { ...file, uploadStatus: -1 };
                  return updatedFiles;
               });
               setUploadError(fetchError || "Unable to connect to server. Please try again.");
               setUploadstatus("status-error");
               uploadFileEmitter.emit("uploadError");
               return;
            }
            if (responseData.st === 1) {
               presignedCount++;
               signurl = responseData.payload[0]["signurl"];
               const uId = responseData.payload[0]["uid"];
               console.log("SIGNED-URL:", signurl, uId);

               // Now, upload the file to S3 using the signed URL
               const uploadStatus = await uploadFileToS3(signurl, file, uId, { signal: abortController.current.signal });
               console.log("S3-PUT-RESPONSE:", uploadStatus);

               uploadDiag("put_result", { index: i, file: file.name, st: uploadStatus?.st, ms: uploadStatus?.ms });

               if (uploadStatus.st === 1 || uploadStatus.st === -1) {
                  setFiles((prevFiles) => {
                     const updatedFiles = [...prevFiles];
                     updatedFiles[i] = { ...file, uploadStatus: uploadStatus.st };

                     // Calculate uploadCount here with updated state
                     const uploadCount = updatedFiles.filter((file) => file.uploadStatus === 1).length;
                     setTotalUploaded(uploadCount);
                     return updatedFiles;
                  });

                  uploadedSize += file.size;
                  const elapsedTime = (Date.now() - startTime) / 1000; // seconds
                  const percentageUploaded = Math.round((uploadedSize / totalFileSize) * 100);
                  const remainingSize = totalFileSize - uploadedSize;
                  const uploadSpeed = (uploadedSize / elapsedTime / 1024).toFixed(1); // KB per second
                  const remainingTime = remainingSize / uploadSpeed; // seconds
                  const remainingMinutes = Math.floor(remainingTime / 60);
                  const remainingSeconds = Math.floor(remainingTime % 60);

                  setProgress(percentageUploaded);
                  setRemainingFiles(files.length - files.indexOf(file) - 1);
                  setRemainingSize(remainingSize);
                  setRemainingTime(`${remainingMinutes} minutes ${remainingSeconds} seconds`);
                  setUploadSpeed(uploadSpeed);

                  if (uploadStatus.st === -1) {
                     setUploadError("Could not upload file to your repository, if the error persists check your network.");
                     setUploadstatus("status-error");
                     uploadFileEmitter.emit("uploadError"); // Notify error
                     return;
                  }
               } else {
                  // If uploadStatus is not 1 or -1, mark the remaining files as cancelled
                  setFiles((prevFiles) => {
                     return prevFiles.map((f, index) => (index >= i ? { ...f, uploadStatus: -2 } : f));
                  });
                  setUploadError(uploadStatus.message);
                  setUploadstatus("status-error");
                  uploadFileEmitter.emit("uploadError"); // Notify error
                  return;
               }
            } else {
               setFiles((prevFiles) => {
                  const updatedFiles = [...prevFiles];
                  updatedFiles[i] = { ...file, uploadStatus: -1 };
                  return updatedFiles;
               });
               //setErrorUploading(responseData.m_en || "We seem to have an issue authenticating, please try again later.");
               setUploadError("Error connecting to the server to authorize upload, if error persists try log out.");
               setUploadstatus("status-error");
               uploadFileEmitter.emit("uploadError"); // Notify error
               return;
            }
         } catch (error) {
            //setErrorUploading(error.message || "An error occurred during file upload.");
            setFiles((prevFiles) => {
               const updatedFiles = [...prevFiles];
               updatedFiles[i] = { ...file, uploadStatus: -1 };
               return updatedFiles;
            });
            setUploadError(error?.message || "An unexpected error occurred during upload.");
            setUploadstatus("status-error");
            uploadFileEmitter.emit("uploadError"); // Notify error
            return;
         }
      }

      // we are here because there was no issue uploading the files
      uploadDiag("batch_complete", { fileCount: files.length });
      uploadDiagDump();
      setUploadstatus("status-success");
      uploadFileEmitter.emit("uploadComplete"); // Notify upload completed successfully
      uploadFileEmitter.emit("uploadEnd"); // Notify upload ended
   };

   useEffect(() => {
      if (!userClaims?.userId || files.length === 0) return;

      uploadFiles();

      return () => {
         // Clean up if the component is unmounted
         console.log("CLEANUP: Cancelling Upload");
         isUserInitiatedAbort.current = false;
         abortController.current.abort();
      };
   }, [userClaims?.userId]);

   useEffect(() => {
      console.log("PROCESSFILE COMPLETED: ", files.length, uploadStatus);

      if (uploadStatus === "status-cancel") {
         console.log("Upload cancelled by user");
         setFiles((prevFiles) => {
            const updatedFiles = prevFiles.map((file) => {
               if (file.uploadStatus === 0) {
                  return { ...file, uploadStatus: -2 }; // Set to -2 (Cancel) if status is not 1
               }
               return file; // Return unchanged if status is 1
            });
            return updatedFiles;
         });
      } else if (uploadStatus === "status-error") {
         console.log("An error occurred during the upload");
         uploadDiag("batch_error");
         uploadDiagDump();
         setFiles((prevFiles) => {
            const updatedFiles = prevFiles.map((file) => {
               if (file.uploadStatus === 0) {
                  return { ...file, uploadStatus: -2 }; // Set to -2 (Cancel) if status is not 1
               }
               return file; // Return unchanged if status is 1
            });
            return updatedFiles;
         });
      } else if (uploadStatus === "status-success") {
         console.log("Upload completed successfully");
         const endTime = Date.now(); // Record the end time
         const tET = endTime - startTime;
         const totalElapsedTime = prettyMs(tET, { verbose: true });
         setTotalElapsedTime(totalElapsedTime);
      }
   }, [uploadStatus]);

   const handleCancel = () => {
      // Trigger the abort signal to cancel the ongoing uploads
      isUserInitiatedAbort.current = true;
      setUploadstatus("status-cancel");
      uploadFileEmitter.emit("uploadEnd"); // Notify upload ended (cancelled)
      abortController.current.abort();
   };

   const handleCloseUpload = async () => {
      navigate("/apps/upload");
   };

   useEffect(() => {
      const handleBeforeUnload = (event) => {
         if (uploading) {
            event.preventDefault();
            event.returnValue = ""; // For older browsers
            dispatchModal({ type: "OPEN_MODAL", payload: { question: "Are you sure you want to leave?" } });
         }
      };

      const handlePopState = (event) => {
         if (uploading) {
            event.preventDefault();
            dispatchModal({ type: "OPEN_MODAL", payload: { question: "Are you sure you want to leave?" } });
            isNavigating.current = true; // Mark navigation as happening
         }
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("popstate", handlePopState);

      return () => {
         window.removeEventListener("beforeunload", handleBeforeUnload);
         window.removeEventListener("popstate", handlePopState);
      };
   }, [uploading]);

   // we listen for the modal dialgue response which is a callback from ModalDialgue
   const handleModalResponse = (response) => {
      if (response === "discard") {
         handleCancel();

         // If they want to discard, allow the back navigation
         if (isNavigating.current) {
            window.history.back(); // Trigger the actual back navigation
         }
      } else if (response === "go_back") {
         dispatchModal({ type: "CLOSE_MODAL", payload: { question: "" } });
         isNavigating.current = false;
      }
   };

   const StatusDisplay = ({ status }) => {
      switch (status) {
         case 1:
            return (
               <div style={{ color: "green", display: "flex", alignItems: "center" }}>
                  <SuccessUpload style={{ marginRight: "3px", height: "1.2em", width: "1.2em" }} />
                  <span style={{ fontWeight: "500" }}>Success</span>
               </div>
            );
         case -1:
            return (
               <div style={{ color: "red", display: "flex", alignItems: "center" }}>
                  <ErrorUpload style={{ marginRight: "3px", height: "1em", width: "1em" }} />
                  <span style={{ fontWeight: "500" }}>Error</span>
               </div>
            );
         case -2:
            return (
               <div style={{ display: "flex", alignItems: "center" }}>
                  <CancelUpload style={{ marginRight: "3px", height: "1em", width: "1em" }} />
                  <span style={{ fontWeight: "500" }}>Cancelled</span>
               </div>
            );
         default:
            return null;
      }
   };

   return (
      <>
         <HeaderUploadStatus onskin={onSkin} status={uploadStatus} onCancel={handleCancel} progress={progress} remainingFiles={remainingFiles} remainingSize={remainingSize} remainingTime={remainingTime} uploadSpeed={uploadSpeed} error={uploadError} totalUploaded={totalUploaded} totalElapsedTime={totalElapsedTime} />
         <div className="main main-app-status p-3 p-lg-4 p-xxl-5}" style={{ marginTop: uploadStatus === "status-uploading" ? "150px" : "100px" }}>
            <Container fluid>
               <Row className="justify-content-start">
                  <Col xs="">
                     <h2 className="main-title fs-2 mb-1">Upload Status</h2>
                     <Row>
                        <div className="d-flex justify-content-between">
                           <div>
                              <h3 className="fs-5 mt-5 mb-1">Files will be uploaded to Rekonsil. Status of each file is displayed below.</h3>
                           </div>
                           <div style={{ display: "flex", alignItems: "flex-end" }}>
                              {uploadStatus !== "status-uploading" && (
                                 <button type="button" onClick={handleCloseUpload} className="btn btn-outline-light btn-cancel-upload pb-1 pt-1 ps-3 pe-3">
                                    Close
                                 </button>
                              )}
                           </div>
                        </div>
                     </Row>
                  </Col>
               </Row>

               <Row className="justify-content-start">
                  <Col xs="auto">
                     <Card className="responsive-card mt-4">
                        <Card.Body className="p-0 m-0">
                           <div style={{ backgroundColor: "#eeeff1" }}>
                              <div className="d-flex justify-content-between align-items-start pt-3 ps-3 pe-3">
                                 <div className="h4">
                                    Files <span className="fw-medium fs-5">{fileCount > 0 && `(${fileCount} Total, ${prettyBytes(totalBytes)})`}</span>
                                 </div>
                              </div>

                              <div className="d-flex justify-content-between ps-3 pe-3 pb-3">
                                 <div>
                                    {/* <input {...getInputProps()} /> */}
                                    <InputGroup className="">
                                       <InputGroup.Text className="search-upload bg-white border-black border-right-0" id="basic-addon1">
                                          <IconSearch size={18} />
                                       </InputGroup.Text>
                                       <FormControl style={{ width: "300px" }} className="border-start-0 border-black ps-0" placeholder="Find by name" aria-label="Find by name" aria-describedby="basic-addon1" value={searchTerm} id="table-filter" onChange={(e) => setSearchTerm(e.target.value)} />
                                    </InputGroup>
                                 </div>
                                 <div id="pagination">
                                    <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
                                 </div>
                              </div>
                           </div>
                           <Table className="upload-table mb-0 table-bordered">
                              <thead>
                                 <tr>
                                    <th className="headings" scope="col">
                                       Name
                                    </th>
                                    <th className="headings" scope="col">
                                       Document Type
                                    </th>
                                    <th className="headings" scope="col">
                                       File Type
                                    </th>
                                    <th className="headings" scope="col">
                                       Size
                                    </th>
                                    <th className="headings" scope="col">
                                       Status
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {currentFiles.length > 0 ? (
                                    currentFiles.map((file) => (
                                       <tr key={file.index}>
                                          <td>{file.name}</td>
                                          <td>{file.docType}</td>
                                          <td>{file.type}</td>
                                          <td>{prettyBytes(file.size)} </td>
                                          <td>
                                             <StatusDisplay status={file.uploadStatus} />
                                          </td>
                                       </tr>
                                    ))
                                 ) : (
                                    <tr>
                                       <td colSpan="4">
                                          <div>No files loaded</div>
                                       </td>
                                    </tr>
                                 )}
                              </tbody>
                           </Table>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
            </Container>

            <Footer />
            <ModalDialogue isOpen={isOpen} question={question} onModalDialogueResponse={handleModalResponse} />
         </div>
      </>
   );
}
